const MAX_EARLY_ERRORS = 20;

export type EarlyErrorEntry =
  | {
      kind: 'error';
      message: string;
      stack?: string;
      filename?: string;
      lineno?: number;
      colno?: number;
      ts: number;
    }
  | {
      kind: 'rejection';
      reason: unknown;
      ts: number;
    };

const earlyErrors: EarlyErrorEntry[] = [];

function pushEntry(entry: EarlyErrorEntry): void {
  if (earlyErrors.length >= MAX_EARLY_ERRORS) return;
  earlyErrors.push(entry);
}

/** Install tiny window listeners before Sentry loads. Dependency-free. */
export function installEarlyErrorBuffer(): void {
  if (typeof window === 'undefined') return;

  window.addEventListener(
    'error',
    (event: ErrorEvent) => {
      pushEntry({
        kind: 'error',
        message: event.message || 'Unknown error',
        stack: event.error instanceof Error ? event.error.stack : undefined,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        ts: Date.now(),
      });
    },
    true,
  );

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    pushEntry({
      kind: 'rejection',
      reason: event.reason,
      ts: Date.now(),
    });
  });
}

export function drainEarlyErrorBuffer(): EarlyErrorEntry[] {
  return earlyErrors.splice(0, earlyErrors.length);
}

/** Test helper */
export function getEarlyErrorBufferSize(): number {
  return earlyErrors.length;
}

export function resetEarlyErrorBufferForTests(): void {
  earlyErrors.length = 0;
}
